if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      constructor() {
        super();

        this.handleIngredients();
      }

      handleIngredients() {
        const ingredientItems = document.querySelectorAll('.product-tabs__nav-link');

        if (ingredientItems) {
          ingredientItems.forEach((item) => {
            item.addEventListener('click', (e) => {
              e.preventDefault();

              const target = item.getAttribute('href').replace('#', '');

              // remove class 'active' from all nav items
              document.querySelectorAll('.product-tabs__nav-link').forEach((item) => item.classList.remove('active'));

              // add 'active' class for specific nav item
              if (item.classList.contains('active')) {
                item.classList.remove('active');
              } else {
                item.classList.add('active');
              }

              // remove class 'active' from all tabs
              document.querySelectorAll('.product-tabs__tabs').forEach((item) => item.classList.remove('active'));

              // add 'active' class for specific tab content
              document.querySelector('.product-tabs__tabs#' + target).classList.add('active');
            });
          });
        }
      }
    }
  );
}
